<template>
  <div class="checkbox-group">
    <a-row>
      <div class="checkbox-wrapper">
        <div class="checkbox" :class="classStr(item)" v-for="item in lineOne" :key="item" @click="onClick">{{ item }}</div>
      </div>
    </a-row>

    <a-row style="margin-top: 20px">
      <div class="checkbox-wrapper">
        <div class="checkbox" :class="classStr(item)" v-for="item in lineTwo" :key="item" @click="onClick">{{ item }}</div>
      </div>
    </a-row>

    <a-row style="margin-top: 20px">
      <div class="checkbox-wrapper">
        <div class="checkbox" :class="classStr(item)" v-for="item in lineThree" :key="item" @click="onClick">{{ item }}</div>
      </div>
    </a-row>
  </div>
</template>

<script>
const MAX_COUNT = 3
export default {
  name: 'CheckboxGroup',
  model: {
    prop: 'result',
    event: 'changeModel'
  },
  props: {
    result: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lineOne: ['APP', '游戏软件', '教育软件', '金融软件', '医疗软件'],
      lineTwo: ['地理信息软件', '云计算软件', '信息安全软件', '大数据软件', '人工智能软件'],
      lineThree: ['VR软件', '5G软件', '小程序', '物联网软件', '智慧城市软件'],
      activeValue: [] // 选中项
    }
  },
  methods: {
    onClick(e) {
      const el = e.currentTarget
      const value = e.target.innerText
      let activeValue = this.activeValue

      if (activeValue.includes(value)) {
        //当前是选中状态
        const index = activeValue.findIndex((item) => item === value)
        activeValue.splice(index, 1)
        el.classList.remove('active')
      } else {
        // 未选中状态
        if (activeValue.length >= MAX_COUNT) {
          return this.$message.warning('最多选3个属性！')
        }
        activeValue.push(value)
        el.classList.add('active')
      }

      // 拼接 v-model 值
      let res = ''
      if (activeValue.length > 0) {
        res = activeValue.join(',')
      }
      this.$emit('changeModel', res)
      this.$emit('change', res)
    },
    classStr(val) {
      const activeValue = this.activeValue
      if (activeValue.includes(val)) {
        return 'active'
      }
    }
  },
  computed: {},
  watch: {
    result: {
      handler(val) {
        if (val) {
          this.activeValue = val.split(',')
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.checkbox-wrapper {
  .checkbox {
    position: relative;
    display: inline-block;
    width: 160px;
    height: 32px;
    margin: 0;
    padding: 0 15px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 30px;
    text-align: center;
    background: #fff;
    border: 1px solid #e9e9e9;
    border-top-width: 1.02px;
    cursor: pointer;
    transition: color 0.3s, background 0.3s, border-color 0.3s, box-shadow 0.3s;
    margin-left: -1px;
    &:hover {
      color: @theme-color;
    }
    &.active {
      color: @theme-color;
      border-color: @theme-color !important;
      background-color: rgba(0, 116, 255, 0.04);
      z-index: 1;
    }
    &:first-child {
      border-left: 1px solid #e9e9e9;
      border-radius: 3px 0 0 3px;
    }
    &:last-child {
      border-radius: 0 3px 3px 0;
    }
  }
}
</style>
